import React from 'react';
import { forwardRef } from 'react';
import { StyledInput, StyledSearchField, StyledSearchIcon, StyledIconButton, StyledIconButtonContainer, StyledUpperContainer, StyledFormMessage } from './index.styles.js';
import {} from '@oneaudi/unified-web-alpha-common';
import { pickA11yProps } from '../../utils/pick-a11y-props.js';
import { Icon } from '../icon/index.js';
import { pickDataProps } from '../../utils/pick-data-props.js';
export const SearchField = forwardRef(({ className, onChange, onClick, onKeyDown, clearButton, value, id, label, hint, placeholder, disabled, autoComplete, inputRef, additionalIconButton, margin, ...rest }, ref) => {
    const hintId = `${id}__hint`;
    const ariaDescribedByProp = pickA11yProps(rest)['aria-describedby'];
    const hasValue = Boolean(value);
    const hasAdditionalIconButton = Boolean(additionalIconButton);
    const ariaDescribedBy = hint || ariaDescribedByProp
        ? [
            hint ? hintId : undefined,
            ariaDescribedByProp ? ariaDescribedByProp : undefined
        ]
            .join(' ')
            .trim()
        : undefined;
    return (React.createElement(StyledSearchField, { className: className, ref: ref, margin: margin, ...pickDataProps(rest) },
        React.createElement(StyledUpperContainer, null,
            React.createElement(StyledSearchIcon, { name: "search", size: "s" }),
            React.createElement(StyledInput, { type: "search", id: id, value: value, onChange: onChange, onClick: onClick, ref: inputRef, onKeyDown: onKeyDown, disabled: disabled, placeholder: placeholder ?? label, autoComplete: autoComplete, ...pickA11yProps(rest), "aria-label": label, "aria-describedby": ariaDescribedBy, hasValue: hasValue, additionalIconButton: hasAdditionalIconButton }),
            (value || additionalIconButton) && (React.createElement(StyledIconButtonContainer, null,
                value && (React.createElement(StyledIconButton, { disabled: disabled, onClick: clearButton.onClick, "aria-label": clearButton['aria-label'] },
                    React.createElement(Icon, { name: "cancel", size: "s" }))),
                additionalIconButton && (React.createElement(StyledIconButton, { disabled: disabled, "aria-label": additionalIconButton['aria-label'], onClick: additionalIconButton.onClick },
                    React.createElement(Icon, { name: additionalIconButton.icon, size: "s" })))))),
        hint && (React.createElement(StyledFormMessage, { variant: "hint", text: hint, id: hintId, disabled: disabled }))));
});
SearchField.displayName = 'SearchField';
//# sourceMappingURL=index.js.map